/**
 * It scrolls to the element with the given target selector, with an optional offset.
 *
 * @param target - The selector (usually an "id") of the element to scroll to.
 * @param offset - The offset to apply to the scroll position.
 */
export const scrollTo = (target: string, offset = 0): void => {
  const element = document.querySelector<HTMLElement>(target)

  if (element) {
    const bodyRect = document.body.getBoundingClientRect().top
    const elementRect = element.getBoundingClientRect().top
    const offsetPosition = elementRect - bodyRect - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }
}
